import utils from '@/utils'

const makeBaseAuth = ({ user, password }) => {
  const tok = `${user}:${password}`
  const hash = btoa(tok)
  return `Basic ${hash}`
}

const token = makeBaseAuth({
  user: process.env.API_USER,
  password: process.env.API_PASSWORD
})

const doFetch = ({ url, options = {} }) => {
  Object.assign(options, {
    headers: {
      Authorization: token
    }
  })

  return fetch(url, options)
    .then(res => res.json())
}

const getCategories = ({ lang }) => {
  return doFetch({
    url: `${process.env.API_URL}/api/v2/solutions/categories/${utils.mapLangs(lang)}`
  })
}

const getCategory = ({ lang, categoryId }) => {
  return doFetch({
    url: `${process.env.API_URL}/api/v2/solutions/categories/${categoryId}/${utils.mapLangs(lang)}`
  })
}

const getFolders = ({ lang, categoryId }) => {
  return doFetch({
    url: `${process.env.API_URL}/api/v2/solutions/categories/${categoryId}/folders/${utils.mapLangs(lang)}`
  })
}

const getFolder = ({ lang, folderId }) => {
  return doFetch({
    url: `${process.env.API_URL}/api/v2/solutions/folders/${folderId}/${utils.mapLangs(lang)}`
  })
}

const getArticles = ({ lang, folderId }) => {
  return doFetch({
    url: `${process.env.API_URL}/api/v2/solutions/folders/${folderId}/articles/${utils.mapLangs(lang)}?per_page=100`
  })
}

const getArticle = ({ lang, articleId }) => {
  return doFetch({
    url: `${process.env.API_URL}/api/v2/solutions/articles/${articleId}/${utils.mapLangs(lang)}`
  })
}

const createTicket = (options) => {
  return doFetch({ url: `${process.env.API_URL}/api/v2/tickets`, options })
}

const createContact = (options) => {
  return doFetch({ url: `${process.env.API_URL}/api/v2/contacts`, options })
}

export default {
  getCategories,
  getCategory,
  getFolders,
  getFolder,
  getArticles,
  getArticle,
  createTicket,
  createContact
}



// WEBPACK FOOTER //
// ./src/api/index.js